module.exports = __webpack_public_path__ + "img/region-europe.167df13b.png";